import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormularioTesteComponent } from './formulario-teste.component';
import { ToolbarModule } from '../../../../shared/components/toolbar/toolbar.module';
import { ContainerPadraoModule } from '../../../../shared/components/container-padrao/container-padrao.module';
import { CardModule } from '../../../../shared/components/card/card.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { LookupModule } from '../../../../shared/components/lookup/lookup.module';
import { TestesAdmService } from 'src/app/shared/api/testes/testes.service';
import { CardMidiaFormularioModule } from '../../../../shared/components/card-midia-formulario/card-midia-formulario.module';
import { ModalModule } from '../../../../shared/components/modal/modal.module';
import { TabelaListagemModule } from '../../../../shared/components/tabela-listagem/tabela-listagem.module';
import { ButtonModule } from '../../../../shared/components/button/button.module';
import { TrilhasService } from 'src/app/shared/api/testes/trilhas.service';
import { CardMidiaModule } from '../../../../shared/components/card-midia/card-midia.module';
import { MidiasTrilhaComponent } from './midias-trilha/midias-trilha.component';
import { AdmMidiasService } from 'src/app/shared/api/testes/adm-midias.service';
import { SelectFormularioModule } from 'src/app/shared/components/select-formulario/select-formulario.module';
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    declarations: [FormularioTesteComponent, MidiasTrilhaComponent],
    imports: [
        CommonModule,
        ToolbarModule,
        ContainerPadraoModule,
        CardModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        LookupModule,
        CardMidiaFormularioModule,
        ModalModule,
        TabelaListagemModule,
        ButtonModule,
        CardMidiaModule,
        SelectFormularioModule,
        MatOptionModule,
        MatSelectModule
    ],
    providers: [TestesAdmService, TrilhasService, AdmMidiasService],

    exports: [FormularioTesteComponent]
})
export class FormularioTesteModule { }
